<template>
  <label class="ConsentCheckbox" :data-testing-target="`Field: ${name}`">
    <div class="inputLayout">
      <input type="checkbox" v-bind="{ name }" class="checkboxInput">
      <span v-html="html" class="text"></span>
    </div>
    <FieldError v-if="error" v-bind="{ error }" class="error" />
  </label>
</template>

<script>
import FieldError from './FieldError.vue'

export default {
  components: {
    FieldError,
  },
  props: {
    name: String,
    value: Boolean,
    html: String,
    error: String,
  },
}
</script>

<style scoped>

.ConsentCheckbox {
  display: block;
  cursor: pointer;
}

.inputLayout {
  display: flex;
}

.checkboxInput {
  flex-shrink: 0;
  width: 1.3rem;
  height: 1.3rem;
  margin-top: 0.3rem;
  cursor: pointer;
}

.text {
  margin-left: var(--spacing-4);
}
</style>
